// Helper function to safely stringify objects with circular references
const safeStringify = (obj: Record<string, unknown>) => {
	try {
		// Create a new object without circular references
		const seen = new WeakSet();
		return JSON.stringify(obj, (_key, value) => {
			// If value is an object and not null
			if (typeof value === "object" && value !== null) {
				// If we've seen this object before, return undefined to avoid circular reference
				if (seen.has(value)) {
					return undefined;
				}
				// Add the value to our collection
				seen.add(value);
			}
			return value;
		});
	} catch (error) {
		// If stringify still fails, return a placeholder
		console.warn("Failed to stringify object:", error);
		return JSON.stringify({ safeStringifyFailed: true });
	}
};

export const pushDataToLayerSafely = (data: Record<string, unknown>) => {
	// Make sure the last object added is not the same as the one we are trying to add
	const dataLayer = window.dataLayer || [];
	if (dataLayer.length > 0) {
		const lastObject = dataLayer[dataLayer.length - 1];
		try {
			// Use the safe stringify method instead of direct JSON.stringify
			if (
				safeStringify({ ...lastObject, "gtm.uniqueEventId": null }) ===
				safeStringify({ ...data, "gtm.uniqueEventId": null })
			) {
				return;
			}
		} catch (error) {
			console.warn("Error comparing dataLayer objects:", error);
			// Continue with the push even if comparison fails
		}
	}
	dataLayer.push(data);
	window.dataLayer = dataLayer;
};

export const pushToNDSDataLayer = (
	screenIndex: NDS.ScreenIndex,
	eventName: NDS.EventName,
	status: NDS.EventStatus,
	value?: string | number | boolean,
) => {
	if (
		eventName === "survey_pageview" &&
		(status === "start" || status === "complete")
	) {
		return pushDataToLayerSafely({
			event: eventName,
			survey_section: screenIndex.route,
			section_status: status,
			survey_url: `${window.location.href}/${screenIndex.route.toLowerCase()}`,
		});
	}
	if (eventName === "survey_pageview") {
		return pushDataToLayerSafely({
			event: eventName,
			survey_section: screenIndex.route,
			question_id: screenIndex.screen,
			survey_url: `${window.location.href}/${screenIndex.route.toLowerCase()}`,
		});
	}
	if (eventName === "survey_consent") {
		return pushDataToLayerSafely({
			event: eventName,
			survey_marketing: value === "yes" ? "yes" : "no",
			survey_url: `${window.location.href}/${screenIndex.route.toLowerCase()}`,
		});
	}
};
